import React from "react";
import styles from "./EntityDetails.module.scss";

const DetailStat = ({ icon, label, value, onClick, fullWidth = false }) => (
  <div
    className={`${styles.statTile} ${fullWidth ? styles.statTileWide : ""} ${onClick ? styles.statTileClickable : ""}`}
    onClick={onClick}
  >
    <span className={styles.statIcon}>{icon}</span>
    <div className={styles.statBody}>
      <p className={styles.statLabel}>{label}</p>
      <p className={styles.statValue}>{value || ""}</p>
    </div>
  </div>
);

export default DetailStat;
